import { Module } from 'vuex'

import { ShopState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ShopState = {
  shopType: 'unchecked',
  shops: [],
  isShopsLoading: false,
}

export const shop: Module<ShopState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
